// 存放登录相关网络请求
import request from "@/utils/request.js"

export const gethomemsg=()=>{
    return request.get("/page/detail",{
        params:{
            pageId:0   
        }
    })
}